/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Assignment_Choose_People_ErrorInputs */

const fr_project_assignment_choose_people_error = /** @type {(inputs: Project_Assignment_Choose_People_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez au moins un collaborateur.`)
};

const en_project_assignment_choose_people_error = /** @type {(inputs: Project_Assignment_Choose_People_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose at least one person.`)
};

/**
* | output |
* | --- |
* | "Choose at least one person." |
*
* @param {Project_Assignment_Choose_People_ErrorInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const project_assignment_choose_people_error = /** @type {((inputs?: Project_Assignment_Choose_People_ErrorInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Assignment_Choose_People_ErrorInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_project_assignment_choose_people_error(inputs)
	return fr_project_assignment_choose_people_error(inputs)
});